import { render, staticRenderFns } from "./Snacks.vue?vue&type=template&id=2408459c&scoped=true"
import script from "./Snacks.vue?vue&type=script&lang=ts"
export * from "./Snacks.vue?vue&type=script&lang=ts"
import style0 from "./Snacks.vue?vue&type=style&index=0&id=2408459c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2408459c",
  null
  
)

export default component.exports